import React from 'react';
import PaymentMethodsTable from '../components/PaymentMethodsTable';

export function PaymentMethods() {
  return <PaymentMethodsTable />;
}
